document.addEventListener("DOMContentLoaded", () => {
  // 採寸ページだけ
  if (!location.pathname.includes("/pages/size-guide")) return;

  // 見出しテキスト → id の対応（表記揺れも吸収）
  const map = [
    { keys: ["バッグ"], id: "size-bag" },
    { keys: ["財布・小物", "財布小物", "財布"], id: "size-wallet" },
    { keys: ["腕時計", "時計"], id: "size-watch" },
    { keys: ["ジュエリー・アクセサリー", "ジュエリー", "アクセサリー"], id: "size-jewelry" },
    { keys: ["アパレル"], id: "size-apparel" },
    { keys: ["ファッション雑貨", "アパレル小物", "雑貨"], id: "size-fashiongoods" },
    { keys: ["シューズ", "靴"], id: "size-shoes" },
  ];

  // ページ内の見出し候補を広めに取得（Riseでも拾う）
  const headings = Array.from(
    document.querySelectorAll("main h1, main h2, main h3, main h4, .shopify-section h2, .shopify-section h3, .shopify-section h4")
  );

  // 文字列を正規化（全角スペースなどを吸収）
  const norm = (s) =>
    (s || "")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  // 見出しテキストが一致したものに id を付与
  headings.forEach((h) => {
    const text = norm(h.textContent);

    map.forEach(({ keys, id }) => {
      // すでに付いていたらスキップ
      if (document.getElementById(id)) return;

      // 完全一致 or 部分一致（「ジュエリー・アクセサリー」などに強い）
      const matched = keys.some((k) => text === k || text.includes(k));
      if (!matched) return;

      h.id = id;
    });
  });

  // もし見出しに付かなかった場合に備えて保険：見出し直前にアンカー挿入（空div）
  map.forEach(({ keys, id }) => {
    if (document.getElementById(id)) return;

    const target = headings.find((h) => keys.some((k) => norm(h.textContent).includes(k)));
    if (!target) return;

    const anchor = document.createElement("div");
    anchor.id = id;
    target.parentNode.insertBefore(anchor, target);
  });
});